import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DsFormsModule } from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';
import { BrandedIdType } from '../../model/branded-id-type';

@Component({
  selector: 'cdf-create-bmw-mini-id-radio-buttons',
  imports: [DsFormsModule, FormsModule],
  template: `
    <h2>{{ i18n('createBmwOrMiniRadioButtons.title') }}</h2>
    <span>{{ i18n('createBmwOrMiniRadioButtons.question') }}</span>

    <div class="row bmw-mini-id">
      <span class="col-auto text-label text-neutral">{{ i18n('createBmwOrMiniIdModal.emailForCreation') }}:</span>
      <span id="used-e-mail" class="col-auto text-label">{{ bmwMiniId() }}</span>
    </div>

    <ds-form-field>
      <ds-radio-group>
        @for (idType of options; track idType) {
          <input
            ds-input
            [id]="'cdf-create-id-radio-' + idType"
            type="radio"
            name="cdf-create-id-radio"
            [value]="idType"
            [attr.value]="idType"
            [(ngModel)]="brandedIdType"
          />
          <label ds-label [for]="'cdf-create-id-radio-' + idType">
            {{ i18n.enum(idType, 'createBmwOrMiniRadioButtons') }}
          </label>
        }
      </ds-radio-group>
    </ds-form-field>
  `,
  styleUrl: './create-bmw-mini-id-radio-buttons.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateBmwMiniIdRadioButtonsComponent {
  protected readonly i18n = useI18n();

  readonly brandedIdType = model.required<BrandedIdType>();
  readonly bmwMiniId = input<string>();

  protected readonly options = [BrandedIdType.NONE, BrandedIdType.MINI, BrandedIdType.BMW];
}
